import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectRelatedCategories = (state: ReduxApplicationState) =>
  state.product.navigation.find((n) => n.type === 'relatedCategories')?.options ?? [];
